import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Copy } from 'lucide-react';
import { ViewPasswordDialogProps } from '../types';

const ViewPasswordDialog: React.FC<ViewPasswordDialogProps> = ({
  user,
  open,
  onClose,
  passwordData,
  loading,
  onCopy,
}) => {
  const hasPassword = Boolean(passwordData?.password_plain);

  const handleCopy = async () => {
    if (!passwordData?.password_plain) {
      return;
    }

    await onCopy(passwordData.password_plain);
  };

  if (!user) return null;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Ver Contraseña</DialogTitle>
          <DialogDescription>
            Contraseña almacenada para <strong>{user.name}</strong> ({user.email})
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="visible-password">Contraseña actual</Label>
            <Input
              id="visible-password"
              readOnly
              value={passwordData?.password_plain ?? ''}
              placeholder={loading ? 'Cargando contraseña...' : 'Sin contraseña disponible'}
            />
          </div>

          {!loading && !hasPassword && (
            <p className="text-sm text-gray-500">
              No hay una contraseña almacenada disponible para este usuario.
            </p>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            Cerrar
          </Button>
          <Button onClick={handleCopy} disabled={loading || !hasPassword}>
            <Copy className="h-4 w-4" />
            Copiar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ViewPasswordDialog;
